import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Layouts & Styles
import DashboardLayout from '../../Layouts/DashboardLayout';

// Redux/actions
import { apiGetAllShootRobotsRequest, apiClearAllShootRobotsRequest } from '../../Redux/actions/gear';

// Components
import RobotStatusDashboard from 'Components/RobotStatusDashboard';

// Constants
import { WebsocketClients, ROBOT_UNKNOWN_VALUE, ROBOT_STATUS_DEFAULT_VALUE } from 'Config/websocketConstants';

const ProjectRobotStatusDashboardPage = () => {
  const { project_id } = useParams();
  const dispatch = useDispatch();

  // useSelector
  const auth = useSelector(state => state.auth);
  const gear = useSelector(state => state.gear);

  // useState
  const [robotAirIdsString, setRobotAirIdsString] = useState(""); // Used for joinning backend channel group
  const [robotAirIds, setRobotAirIds] = useState([]);
  const [robotAirIdstoNickNames, setRobotAirIdstoNickNames] = useState({});
  const [robotAirIdstoProjectPlaceholders, setRobotAirIdstoProjectPlaceholders] = useState({});

  useEffect(() => {
    dispatch(apiClearAllShootRobotsRequest());
    dispatch(apiGetAllShootRobotsRequest(auth.token, project_id));
    return (() => {
      dispatch(apiClearAllShootRobotsRequest());
    })
  }, []);

  useEffect(() => {
    if (gear.shootRobots && robotAirIds.length === 0) {
      let targetAirIds = [];
      let robotAidIdNameObj = {};
      let airIdToPlaceholder = {};
      gear.shootRobots.forEach(shootRobot => {
        targetAirIds.push(shootRobot.air_id);
        robotAidIdNameObj[shootRobot.air_id] = shootRobot?.shoot_robot_nick_name ?? ROBOT_UNKNOWN_VALUE;
        let curPlaceHolder = shootRobot?.robot_placeholder
        if ((typeof curPlaceHolder === "string" && curPlaceHolder.trim() === "") || curPlaceHolder === null) {
          airIdToPlaceholder[shootRobot.air_id] = ROBOT_STATUS_DEFAULT_VALUE
        } else {
          airIdToPlaceholder[shootRobot.air_id] = curPlaceHolder;
        }
      });
      setRobotAirIdsString(targetAirIds.join(","));
      setRobotAirIds(targetAirIds);
      setRobotAirIdstoNickNames(robotAidIdNameObj);
      setRobotAirIdstoProjectPlaceholders(airIdToPlaceholder);
    }
  }, [gear.shootRobots]);

  return (
    <DashboardLayout>
      <RobotStatusDashboard
        dashboardHeader={'Project Robot Status Dashboard'}
        dashboardSubHeader={'View Project Robot Real-time Status In One Dashboard'}
        robotAirIdsString={robotAirIdsString}
        robotAirIds={robotAirIds}
        robotAirIdstoNickNames={robotAirIdstoNickNames}
        wsClientName={WebsocketClients.SHOOT_ROBOT_STATUS}
        robotAirIdsToProjectPlaceholders={robotAirIdstoProjectPlaceholders}
      />
    </DashboardLayout>
  );
};

export default ProjectRobotStatusDashboardPage;
